module.exports = __webpack_public_path__ + "img/advantage-item03.5b749bd2.png";